import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";
import {
  PRODUCT_HANDLER,
  PRODUCT_TYPES,
  PRODUCTS,
  SUB_PRODUCTS,
} from "./Texts";
import { store } from "../redux";

export const CurrencyConverter = (amount, maximumFractionDigits) => {
  const formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    currencyDisplay: "symbol",
    minimumFractionDigits: maximumFractionDigits || 0,
    maximumFractionDigits: maximumFractionDigits,
  });
  return formatter.format(amount).replace("₹", "₹ ");
};
//MASK
export const MaskStringUptoLastChars = (str) => {
  if (str.length <= 4) {
    return str;
  } else {
    const maskedPart = "*".repeat(str.length - 4);
    const lastPart = str.slice(-4);
    return maskedPart + lastPart;
  }
};

// Format timeLeft as MM:SS
export const FormatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

export const STAGE_BASED_ROUTING = (stage, type) => {
  const routeMap = {
    APPLY_LOAN: "/personal-loan/apply-loan",
    LOAN_AMOUNT: "/personal-loan/apply-loan",
    PAN: "/personal-loan/identity-details",
    CKYC: "/personal-loan/identity-details",
    ADD_ADDRESS: "/personal-loan/personal-details",
    PERSONAL_DETAILS: "/personal-loan/personal-details",
    OFFERS: "/personal-loan/offers",
    DIGI_KYC: "/personal-loan/face-verification",
    EKYC: "/personal-loan/ekyc-verification",
    WORK_DETAILS: "/personal-loan/work-details",
    MANDATE: "/personal-loan/mandate/repayment-setup",
    MANDATE_PENNYDROP: "/personal-loan/mandate/repayment-banking",
    E_SIGN: "/personal-loan/e-sign",
    E_SIGN_KFS_INCOMPLETE: "/personal-loan/e-sign",
    BRE_CPV_TVR: "/personal-loan/conditional-approval",
    LMS_ONBOARDING: "/personal-loan/conditional-approval",
    DISBURSED: "/personal-loan/disbursed",
    REVERSE_PENNY_DROP: "/personal-loan/rpd",
    VKYC: "/personal-loan/video-kyc",
    VKYC_SCHEDULED: "/personal-loan/video-kyc",
    RPD_MODE: "/personal-loan/verification-mode",
    PAN_AADHAAR_LINK_PENDING: "/personal-loan/face-verification",
  };

  let route = routeMap[stage];

  const productType = store.getState().applicationSlice.productType;
  if (type) {
    route = route?.replace("/personal-loan", `/${type}`);
  } else if (
    !type &&
    productType &&
    productType !== PRODUCT_TYPES.PERSONAL_LOAN
  ) {
    route = route?.replace("/personal-loan", `/${productType}`);
  }
  return route || "/";
};

export const GET_PRODUCT_APPLICATION = (product, data) => {
  let type = product;
  let product_type = type;
  let subProductType = null;
  let applicationData = null;

  switch (type) {
    case PRODUCTS.RL:
      product_type = PRODUCTS.PL;
      subProductType = SUB_PRODUCTS.RL;

      applicationData = data?.applications?.find(
        (item) =>
          item?.product_type === product_type &&
          item?.sub_product_type === subProductType,
      );
      break;

    default:
      product_type = PRODUCTS.PL;
      subProductType = SUB_PRODUCTS.PL;

      applicationData = data?.applications?.find(
        (item) =>
          item?.product_type === product_type &&
          (item?.sub_product_type === subProductType ||
            !item?.sub_product_type),
      );
      break;
  }

  return applicationData;
};

export const errorValidator = (errorMessage) => {
  const message = errorMessage?.data?.message;
  const detail = errorMessage?.data?.detail;
  const status = errorMessage?.status || errorMessage?.data?.status;
  const originalStatus =
    errorMessage?.data?.originalStatus || errorMessage?.originalStatus;
  if (message) return message;
  if (detail) return detail;
  if (status) return status;
  if (originalStatus) return originalStatus;
  if (status === "FETCH_ERROR") return errorMessage?.error;
  return "Something went wrong. Please try later";
};

export const resCodeErrorValidator = (responseCode) => {
  const errorMap = {
    UPIErr001: { name: "Technical Issue", description: "Invalid MerchantKey" },
    UPIErr002: { name: "Technical Issue", description: "Invalid AppId" },
    UPIErr003: {
      name: "Technical Issue",
      description: "Mandatory Data blank or invalid",
    },
    UPIErr004: { name: "Technical Issue", description: "Invalid Mandate ID" },
    UPIErr005: {
      name: "Name Mismatch",
      description:
        "Your application is under process. Please check after sometime.",
    },
    UPIErr006: { name: "Authentication Error", description: "Invalid Token" },
    UPIErr007: {
      name: "Technical Issue",
      description: "Technical issue at Bank/PSP End",
    },
    UPIErr008: { name: "Technical Issue", description: "Invalid UMRN" },
    UPIRes004: {
      name: "Authentication Error",
      description: "UPI Mandate Rejected",
    },
    UPIRes005: { name: "Authentication Error", description: "UMN Cancelled" },
  };
  return errorMap[responseCode] || null;
};

export const FormatDateDMY = (dateString) => {
  if (dateString) {
    const [day, month, year] = dateString?.split("-");
    const date = new Date(`${year}-${month}-${day}`);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }
};

export const Base64ToPDF = ({ base64Data }) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length)
    .fill()
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = "file.pdf";
  link.click();
  URL.revokeObjectURL(blobUrl);
};

export const TimeZoneConverter = (date) => {
  if (!date) {
    return {
      formattedDate: "Invalid Date",
      formattedTime: "Invalid Time",
    };
  }
  const [datePart, timePart] = date?.split("T");
  const formattedDate = dayjs(datePart).isValid()
    ? dayjs(datePart).format("DD/MM/YYYY")
    : "Invalid Date";
  const formattedTime = dayjs(`1970-01-01T${timePart}`).isValid()
    ? dayjs(`1970/01/01T${timePart}`).format("h:mm A")
    : "Invalid Time";
  return { formattedDate, formattedTime };
};

export const IsDifferenceGreaterThan72Hours = (date) => {
  const { formattedDate, formattedTime } = TimeZoneConverter(date);
  if (formattedDate === "Invalid Date" || formattedTime === "Invalid Time") {
    return false;
  }
  const inputDateTime = dayjs(
    `${formattedDate} ${formattedTime}`,
    "DD/MM/YYYY h:mm A",
  );
  const currentDateTime = dayjs();
  const differenceInHours = currentDateTime.diff(inputDateTime, "hour");
  return differenceInHours > 72;
};

export const Add72hours = (date) => {
  const { formattedDate, formattedTime } = TimeZoneConverter(date);
  if (formattedDate === "Invalid Date" || formattedTime === "Invalid Time") {
    return false;
  }
  const inputDateTime = dayjs(
    `${formattedDate} ${formattedTime}`,
    "DD/MM/YYYY h:mm A",
  );
  const newDateTime = inputDateTime.add(72, "hour");
  return newDateTime.format("DD/MM/YYYY");
};

export function getPersistentDeviceId() {
  const key = "hfcl_device_id";
  let deviceId = null;
  if (typeof window !== "undefined") {
    deviceId = localStorage.getItem(key);
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem(key, deviceId);
    }
  }
  return deviceId || uuidv4();
}

export function throttle(fn, delay) {
  let lastCall = 0;
  return (...args) => {
    const now = new Date().getTime();
    if (now - lastCall >= delay) {
      lastCall = now;
      fn(...args);
    }
  };
}

export const createInsuranceUrl = (params) => {
  let url = "";
  for (const key in params) {
    url = `${url}${key}=${params[key]}&`;
  }
  url = url.slice(0, -1);
  return url;
};

export function toTitleCase(str = "") {
  if (!str.trim()) return "";

  return str
    .toLowerCase()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}
